<template>
  <v-app>
    <navigaton></navigaton>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Navigaton from "./components/Navigation"

export default {
  name: 'App',
  components: {
      Navigaton,
  },
  data () {
    return {
      //
    }
  }
}
</script>
